export default {
  variant: 'cards.secondary',
  borderRadius: `xl`,
  p: 4,
  '@media(max-width: 370px)': {
    p: 3
  }
}
